export type Category = {
  id: number;
  name: string;
  slug: string;
  description: string | null;
  active: boolean;
  sort_order: number;
};

export type ProductImage = {
  id: number;
  alt_text: string;
  url_small: string;
  url_medium: string;
  url_large: string;
  sort_order: number;
};

export type ProductSize = { id: number; label: string; sort_order: number };

export type Product = {
  id: number;
  name: string;
  slug: string;
  price_cents: number;
  description: string;
  materials_care: string;
  turnaround: string;
  status: "draft" | "published" | "unavailable" | "archived";
  featured: boolean;
  sort_order: number;
  category: Category;
  sizes: ProductSize[];
  images: ProductImage[];
  created_at: string;
  updated_at: string;
};

export type SiteSettings = {
  id: number;
  announcement: string;
  hero_eyebrow: string;
  hero_headline: string;
  hero_body: string;
  hero_image_url: string | null;
  story_title: string;
  story_body: string;
  story_image_url: string | null;
  shipping_message: string;
  shipping_policy: string;
  returns_policy: string;
  contact_email: string;
  instagram_url: string | null;
  tiktok_url: string | null;
  flat_shipping_cents: number;
  free_shipping_threshold_cents: number;
  default_turnaround: string;
  checkout_enabled: boolean;
};

export type Storefront = {
  settings: SiteSettings;
  categories: Category[];
  featured_products: Product[];
  newest_products: Product[];
};

export type Admin = { id: number; email: string; display_name: string };

export type OrderItem = {
  id: number;
  product_id: number | null;
  product_name: string;
  product_slug: string;
  category_name: string;
  size: string | null;
  quantity: number;
  unit_price_cents: number;
  line_total_cents: number;
  image_url: string | null;
};

export type Order = {
  id: number;
  number: string;
  public_token: string;
  customer_email: string | null;
  customer_name: string | null;
  customer_phone: string | null;
  address_line1: string | null;
  address_line2: string | null;
  address_city: string | null;
  address_state: string | null;
  address_postal_code: string | null;
  address_country: string | null;
  currency: string;
  subtotal_cents: number;
  shipping_cents: number;
  tax_cents: number;
  total_cents: number;
  payment_status: string;
  fulfillment_status: string;
  carrier: string | null;
  tracking_number: string | null;
  internal_notes: string | null;
  paid_at: string | null;
  created_at: string;
  updated_at: string;
  items: OrderItem[];
};

export type ContactMessage = {
  id: number;
  name: string;
  email: string;
  order_number: string | null;
  message: string;
  read: boolean;
  created_at: string;
};

export function money(cents: number) {
  return new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(cents / 100);
}

